/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion, URL_SERVICIO_NEGOCIO } from '../../conexiones';
import IDocumentoEvidencia from './entidades/documentoEvidencia';
import DatosDocumentoEvidencia from './entidades/datosDocumentoEvidencia';

export default class ModeloFilas {
    
    public async GuardarDocumentoEvidencia(
        documentoEvidencia: Partial<IDocumentoEvidencia>,
        archivo: File,
        token: string
    ) { 
        var bodyFetch = new FormData();
        bodyFetch.append('DatosEvidencia', JSON.stringify(documentoEvidencia));
        bodyFetch.append('Archivo', archivo);
        let respuestaPeticion = await fetch(
            `${ process.env.REACT_APP_URL_NEGOCIO_CONFIGURACION!}DocumentoEvidencia/GuardarDocumentoEvidencia`,
            {
                method: 'POST',
                body: bodyFetch,
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return respuestaPeticion.status === 200 ? true : false;
    }

    public EliminarDocumentoEvidencia(documentoEvidencia: Partial<IDocumentoEvidencia>) {
        return manejadorRest<IRespuesta<IDocumentoEvidencia>>(
            () => negocioConfiguracion.delete('DocumentoEvidencia/EliminarDocumentoEvidencia', documentoEvidencia),
            true
        );
    }   

    public ConsultarDocumentoEvidencia(documentoEvidencia: Partial<IDocumentoEvidencia>) {
        return manejadorRest<IRespuesta<DatosDocumentoEvidencia>>(
            () => negocioConfiguracion.post('DocumentoEvidencia/ConsultarDocumentoEvidenciaPorFiltro', documentoEvidencia),
            true
        );
    }
}
